import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatDate, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { STR_AT_LEAST_ONE_IMAGE, STR_AVAILABLE_QUANTITY, STR_CATEGORY, STR_CROPS, STR_IMAGES, STR_INVALID_LOCATION, STR_INVALID_QUANTITY, STR_INVALID_TITLE, STR_INVALID_UNIT_PRICE, STR_ITEM_DESCRIPTION, STR_ITEM_LOCATION, STR_ITEM_TITLE, STR_LIVESTOCK, STR_MOQ, STR_PENDING, STR_POST_ITEM, STR_REJECTED, STR_SUBMIT, STR_SUCCESS, STR_UNIT, STR_UNIT_PRICE } from "../Strings";


export default function View({ data }) {

	const appContext = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	
	function view(){
		appContext.navTo({
			item: 'view',
			subItem: 'withdrawal-request',
			extraItem: data.uuid,
		})
	}

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	
	return (
		<div 
			className="bg-surface mShadow1"
			style={{
				width: "100%",
				marginBottom: "20px", 
				cursor: "pointer",
				borderRadius: "10px",
				overflow: "hidden",
				padding: "10px"
			}}
			onClick={view}
		>
			

			<h6
				style={{
					fontSize: "18px"
				}}
			>
				{data.withdrawalMethod}
			</h6>

			<h6
				style={{
					fontSize: "18px"
				}}
			>
				{(data.status === 'pending') ? <span style={{ fontSize: "12px" }} className="badge bg-dark">{STR_PENDING[appContext.language]}</span>: ""}
				{(data.status === 'success') ? <span style={{ fontSize: "12px" }} className="badge bg-success">{STR_SUCCESS[appContext.language]}</span>: ""}
				{(data.status === 'rejected') ? <span style={{ fontSize: "12px" }} className="badge bg-danger">{STR_REJECTED[appContext.language]}</span>: ""}
			</h6>

			

			<h6
				style={{
					fontSize: "20px"
				}}
				className="text-end font-bold"
			>
				{formatMoney(data.amount)} TZS
			</h6>

			<h6
				style={{
					fontSize: "10px"
				}}
				className="text-end font-bold text-muted"
			>
				{formatDate(data.dateCreated)}
			</h6>
			
		</div>
	)
	
}